import {
  faArrowsRotate,
  faSpinner,
  faXmark,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import React from "react";
import { useFormContext } from "react-hook-form";

import { isPreviewDisabled } from "../../utils";

const FooterSection = ({
  control,
  setShouldShowDeleteModal,
  loadingExtraction,
  handlePreview,
  loadingPreview,
  setShouldExpandPreview,
}) => {
  const {
    watch,
    setValue,
    formState: { dirtyFields },
  } = useFormContext(control);
  const formData = watch();
  const isPreviewCurrentlyDisabled = isPreviewDisabled(
    formData,
    dirtyFields,
  );

  const handleClearPreview = () => {
    setValue("preview", "", { shouldDirty: false });
    setShouldExpandPreview(false);
  };

  return (
    <div className="fixed z-30 bottom-0 left-0 right-0 bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 p-4 flex justify-center items-center gap-4">
      <button
        type="button"
        onClick={() => setShouldShowDeleteModal(true)}
        className="inline-flex justify-center py-3 px-5 border border-transparent shadow-sm text-sm font-medium rounded-full text-white bg-red-400 hover:bg-red-500 transition-colors"
      >
        Delete Template
      </button>

      <Tooltip
        arrow
        placement="top"
        title={
          formData.preview
            ? "Clear the current preview"
            : isPreviewCurrentlyDisabled
            ? "There are no changes to preview."
            : ""
        }
      >
        <span>
          <button
            type="button"
            data-testid="preview-template-button"
            className={`py-3 px-5 shadow-sm text-sm font-medium rounded-full transition-colors ${
              formData.preview
                ? "bg-transparent border border-red-400 text-red-400 hover:bg-red-100 dark:hover:bg-red-900/20"
                : "bg-indigo-500 hover:bg-indigo-600 text-white"
            } disabled:bg-gray-300 dark:disabled:bg-gray-700 disabled:cursor-not-allowed`}
            onClick={
              formData.preview ? handleClearPreview : handlePreview
            }
            disabled={
              !formData.preview &&
              (loadingPreview || isPreviewCurrentlyDisabled)
            }
          >
            {loadingPreview ? (
              <>
                Generating Preview
                <FontAwesomeIcon
                  className="ml-2 animate-spin"
                  icon={faSpinner}
                />
              </>
            ) : formData.preview ? (
              <>
                Clear Preview
                <FontAwesomeIcon className="ml-2" icon={faXmark} />
              </>
            ) : (
              <div className="flex items-center">
                Preview Changes
                <FontAwesomeIcon
                  className="ml-2"
                  icon={faArrowsRotate}
                />
              </div>
            )}
          </button>
        </span>
      </Tooltip>
      <Tooltip
        arrow
        placement="top"
        title={
          !formData?.name
            ? "Please fill required fields to save."
            : ""
        }
      >
        <span>
          <button
            type="submit"
            disabled={!formData?.name || loadingExtraction}
            className={`py-3 px-5 shadow-sm text-sm text-white font-medium rounded-full transition-colors ${
              !formData?.name || loadingExtraction
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-indigo-500 hover:bg-indigo-600 cursor-pointer"
            } disabled:bg-gray-300 dark:disabled:bg-gray-700 disabled:cursor-not-allowed`}
            data-testid="save-template-button"
          >
            Save Template
          </button>
        </span>
      </Tooltip>
    </div>
  );
};

export default FooterSection;
